/**
 * @generated SignedSource<<4e21144c24bb6a5a4da9c4b59763c9b0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutDeliveryOptionsQueryRenderer_buyer$data = {
  readonly addressBook: {
    readonly addressList: ReadonlyArray<{
      readonly city: string | null;
      readonly country: string | null;
      readonly serviceId: string | null;
      readonly state: string | null;
      readonly zipCode: string | null;
    } | null> | null;
  } | null;
  readonly serviceId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutTransactionQueryRenderer_buyer" | "checkoutRelayAction_buyer" | "checkoutSetUpActionsSetUpPanes_buyer" | "checkoutSetUpActions_buyer" | "checkoutUIActions_buyer" | "usePreloadedDuties_buyer">;
  readonly " $fragmentType": "CheckoutDeliveryOptionsQueryRenderer_buyer";
};
export type CheckoutDeliveryOptionsQueryRenderer_buyer$key = {
  readonly " $data"?: CheckoutDeliveryOptionsQueryRenderer_buyer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutDeliveryOptionsQueryRenderer_buyer">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "RootArgument",
    "name": "partialAddressCheckoutEligibility"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v2 = [
  {
    "kind": "Variable",
    "name": "partialAddressCheckoutEligibility",
    "variableName": "partialAddressCheckoutEligibility"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "country",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "city",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "zipCode",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "UserPreferences",
  "kind": "LinkedField",
  "name": "preferences",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currency",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v8 = [
  (v1/*: any*/)
],
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "AddressValidation",
  "kind": "LinkedField",
  "name": "validation",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ValidationResult",
      "kind": "LinkedField",
      "name": "buyerShipping",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "valid",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v10 = [
  (v1/*: any*/),
  (v9/*: any*/)
],
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "Address",
  "kind": "LinkedField",
  "name": "addressList",
  "plural": true,
  "selections": (v10/*: any*/),
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currencies",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "paymentProcessor",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "apiType",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "token",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isExpired",
  "storageKey": null
},
v18 = [
  (v16/*: any*/)
],
v19 = {
  "kind": "InlineFragment",
  "selections": (v18/*: any*/),
  "type": "ACH",
  "abstractKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "Address",
  "kind": "LinkedField",
  "name": "shippingAddresses",
  "plural": true,
  "selections": (v8/*: any*/),
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasCreditCards",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasBankAccounts",
  "storageKey": null
},
v23 = {
  "kind": "InlineDataFragmentSpread",
  "name": "checkoutPayment_buyer",
  "selections": [
    (v7/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Wallet",
      "kind": "LinkedField",
      "name": "wallet",
      "plural": false,
      "selections": [
        (v21/*: any*/),
        (v22/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "WalletPaymentMethod",
          "kind": "LinkedField",
          "name": "paymentMethods",
          "plural": true,
          "selections": [
            (v12/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "paymentMethod",
              "plural": false,
              "selections": [
                (v15/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v16/*: any*/),
                    (v13/*: any*/)
                  ],
                  "type": "PayPalAccount",
                  "abstractKey": null
                }
              ],
              "storageKey": null
            },
            (v20/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "args": null,
  "argumentDefinitions": ([]/*: any*/)
},
v24 = {
  "kind": "InlineDataFragmentSpread",
  "name": "checkoutTransactionReducer_buyer",
  "selections": [
    (v1/*: any*/),
    (v7/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Address",
      "kind": "LinkedField",
      "name": "firstValidShippingAddress",
      "plural": false,
      "selections": (v8/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": (v2/*: any*/),
      "concreteType": "AddressBook",
      "kind": "LinkedField",
      "name": "addressBook",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Address",
          "kind": "LinkedField",
          "name": "personalAddress",
          "plural": false,
          "selections": (v8/*: any*/),
          "storageKey": null
        },
        (v11/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Wallet",
      "kind": "LinkedField",
      "name": "wallet",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "WalletPaymentMethod",
          "kind": "LinkedField",
          "name": "paymentMethods",
          "plural": true,
          "selections": [
            (v12/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "paymentMethod",
              "plural": false,
              "selections": [
                (v13/*: any*/),
                (v14/*: any*/),
                (v15/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v16/*: any*/),
                    (v17/*: any*/)
                  ],
                  "type": "CreditCard",
                  "abstractKey": null
                },
                (v19/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": (v18/*: any*/),
                  "type": "PayPalAccount",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": (v18/*: any*/),
                  "type": "ApplePay",
                  "abstractKey": null
                }
              ],
              "storageKey": null
            },
            (v20/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v23/*: any*/)
  ],
  "args": null,
  "argumentDefinitions": (v0/*: any*/)
},
v25 = [
  (v3/*: any*/)
],
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "priceBookName",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "concreteType": "Address",
  "kind": "LinkedField",
  "name": "firstValidShippingAddress",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    (v26/*: any*/)
  ],
  "storageKey": null
},
v28 = [
  (v1/*: any*/),
  (v9/*: any*/),
  (v26/*: any*/)
],
v29 = {
  "alias": null,
  "args": null,
  "concreteType": "Address",
  "kind": "LinkedField",
  "name": "personalAddress",
  "plural": false,
  "selections": (v28/*: any*/),
  "storageKey": null
};
return {
  "argumentDefinitions": (v0/*: any*/),
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutDeliveryOptionsQueryRenderer_buyer",
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": (v2/*: any*/),
      "concreteType": "AddressBook",
      "kind": "LinkedField",
      "name": "addressBook",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Address",
          "kind": "LinkedField",
          "name": "addressList",
          "plural": true,
          "selections": [
            (v1/*: any*/),
            (v3/*: any*/),
            (v4/*: any*/),
            (v5/*: any*/),
            (v6/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutTransactionQueryRenderer_buyer"
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "checkoutRelayAction_buyer",
      "selections": [
        (v24/*: any*/),
        {
          "kind": "InlineDataFragmentSpread",
          "name": "checkoutShippingReducer_buyer",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Profile",
              "kind": "LinkedField",
              "name": "profile",
              "plural": false,
              "selections": (v25/*: any*/),
              "storageKey": null
            },
            (v27/*: any*/),
            {
              "alias": null,
              "args": (v2/*: any*/),
              "concreteType": "AddressBook",
              "kind": "LinkedField",
              "name": "addressBook",
              "plural": false,
              "selections": [
                (v29/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Address",
                  "kind": "LinkedField",
                  "name": "addressList",
                  "plural": true,
                  "selections": [
                    (v1/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "firstName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "lastName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "company",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "line1",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "line2",
                      "storageKey": null
                    },
                    (v3/*: any*/),
                    (v5/*: any*/),
                    (v4/*: any*/),
                    (v6/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "phoneNumber",
                      "storageKey": null
                    },
                    (v9/*: any*/),
                    (v26/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "args": null,
          "argumentDefinitions": (v0/*: any*/)
        },
        {
          "kind": "InlineDataFragmentSpread",
          "name": "checkoutPaymentReducer_buyer",
          "selections": [
            (v23/*: any*/),
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Profile",
              "kind": "LinkedField",
              "name": "profile",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "preventEmailFallback",
                      "value": true
                    }
                  ],
                  "kind": "ScalarField",
                  "name": "displayName",
                  "storageKey": "displayName(preventEmailFallback:true)"
                },
                (v3/*: any*/)
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Address",
              "kind": "LinkedField",
              "name": "firstValidShippingAddress",
              "plural": false,
              "selections": (v25/*: any*/),
              "storageKey": null
            },
            {
              "alias": "isTrade",
              "args": null,
              "kind": "ScalarField",
              "name": "isVerifiedTrade",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Wallet",
              "kind": "LinkedField",
              "name": "wallet",
              "plural": false,
              "selections": [
                (v21/*: any*/),
                (v22/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "WalletPaymentMethod",
                  "kind": "LinkedField",
                  "name": "paymentMethods",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": null,
                      "kind": "LinkedField",
                      "name": "paymentMethod",
                      "plural": false,
                      "selections": [
                        (v14/*: any*/),
                        {
                          "kind": "InlineFragment",
                          "selections": (v18/*: any*/),
                          "type": "CreditCard",
                          "abstractKey": null
                        },
                        (v19/*: any*/)
                      ],
                      "storageKey": null
                    },
                    (v20/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": (v2/*: any*/),
              "concreteType": "AddressBook",
              "kind": "LinkedField",
              "name": "addressBook",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Address",
                  "kind": "LinkedField",
                  "name": "personalAddress",
                  "plural": false,
                  "selections": (v10/*: any*/),
                  "storageKey": null
                },
                (v11/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "args": null,
          "argumentDefinitions": (v0/*: any*/)
        }
      ],
      "args": null,
      "argumentDefinitions": []
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "checkoutUIActions_buyer",
      "selections": [
        (v24/*: any*/)
      ],
      "args": null,
      "argumentDefinitions": []
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "checkoutSetUpActions_buyer",
      "selections": [
        {
          "kind": "InlineDataFragmentSpread",
          "name": "checkoutUIActionsTransactionSetup_buyer",
          "selections": [
            {
              "kind": "InlineDataFragmentSpread",
              "name": "checkoutUIReducer_buyer",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasSupportedChargeCurrency",
                  "storageKey": null
                },
                (v7/*: any*/)
              ],
              "args": null,
              "argumentDefinitions": []
            }
          ],
          "args": null,
          "argumentDefinitions": []
        },
        {
          "kind": "InlineDataFragmentSpread",
          "name": "checkoutTrackingActions_buyer",
          "selections": [
            (v1/*: any*/),
            {
              "kind": "InlineDataFragmentSpread",
              "name": "getPartialVsFullAddressTrackingLabels_buyer",
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "CheckoutShippingAddressList_buyer"
                },
                {
                  "alias": null,
                  "args": (v2/*: any*/),
                  "concreteType": "AddressBook",
                  "kind": "LinkedField",
                  "name": "addressBook",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "personalAddressId",
                      "storageKey": null
                    },
                    (v11/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "args": null,
              "argumentDefinitions": (v0/*: any*/)
            }
          ],
          "args": null,
          "argumentDefinitions": []
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Profile",
          "kind": "LinkedField",
          "name": "profile",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "email",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "checkoutSetUpActionsSetUpPanes_buyer",
      "selections": [
        {
          "kind": "InlineDataFragmentSpread",
          "name": "checkoutPaneReducer_buyer",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isUsingSupportedChargeCurrency",
              "storageKey": null
            },
            (v7/*: any*/),
            (v27/*: any*/),
            {
              "alias": null,
              "args": (v2/*: any*/),
              "concreteType": "AddressBook",
              "kind": "LinkedField",
              "name": "addressBook",
              "plural": false,
              "selections": [
                (v29/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Address",
                  "kind": "LinkedField",
                  "name": "addressList",
                  "plural": true,
                  "selections": (v28/*: any*/),
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Wallet",
              "kind": "LinkedField",
              "name": "wallet",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "WalletPaymentMethod",
                  "kind": "LinkedField",
                  "name": "paymentMethods",
                  "plural": true,
                  "selections": [
                    (v12/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": null,
                      "kind": "LinkedField",
                      "name": "paymentMethod",
                      "plural": false,
                      "selections": [
                        (v13/*: any*/),
                        (v14/*: any*/),
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            (v17/*: any*/)
                          ],
                          "type": "CreditCard",
                          "abstractKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    (v20/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "args": null,
          "argumentDefinitions": (v0/*: any*/)
        }
      ],
      "args": null,
      "argumentDefinitions": []
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "usePreloadedDuties_buyer"
    }
  ],
  "type": "User",
  "abstractKey": null
};
})();

(node as any).hash = "76596d51a3a5c143172318c71c00e325";

export default node;
